import { procurementAPI } from "../../axios";

export const actions = {
    // PRItemDetail
    CreateSinglePRItemDetail(context, data){
        return procurementAPI.post(`MigrationPrItemDetail/Create`, data);
    },
    CreateMultiplePRItemDetail(context, data){
        return procurementAPI.post(`MigrationPrItemDetail/Create/Multiple`, data);
    },
    GetSinglePRItemDetail(context, data){
        return procurementAPI.get(`MigrationPrItemDetail/${data}`);
    },
    UpdatePRItemDetail(context, data){
        return procurementAPI.put(`MigrationPrItemDetail/${data}`);
    },
    DeletePRItemDetail(context, data){
        return procurementAPI.delete(`MigrationPrItemDetail/${data}`);
    },
    GetPRItemDetailByPRItem(context, data){
        return procurementAPI.get(`MigrationPrItemDetail/MigrationPrItem/${data}`);
    },
}